import {
    apiRequest,
    levelTunjanganKhususList,
    levelTunjanganKhususActive,
    levelTunjanganKhususInactive,
} from "../../../../../services/adapters/master/levelTunjanganKhususService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", levelTunjanganKhususList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", levelTunjanganKhususInactive, {
            body: query
        }, true)
    }

    fetchActive = async (query) => {
        return await apiRequest("post", levelTunjanganKhususActive, {
            body: query
        }, true)
    }
}

export default DataTableRepository